/* ATN Sample Showroom - horizontal card slider
   Scrolls the track by one visible page. No dependencies. */
(function () {
  'use strict';

  function setup(slider) {
    if (slider.dataset.atnSsSliderReady === 'true') return;
    slider.dataset.atnSsSliderReady = 'true';

    var track = slider.querySelector('[data-atn-ss-track]');
    var prev = slider.querySelector('[data-atn-ss-prev]');
    var next = slider.querySelector('[data-atn-ss-next]');
    if (!track) return;

    function step() {
      var card = track.firstElementChild;
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      var cardWidth = card.getBoundingClientRect().width + gap;
      var perView = Math.max(1, Math.round(track.clientWidth / cardWidth));
      return cardWidth * perView;
    }

    function refresh() {
      var max = track.scrollWidth - track.clientWidth - 1;
      var scrollable = max > 0;
      if (prev) prev.hidden = !scrollable || track.scrollLeft <= 0;
      if (next) next.hidden = !scrollable || track.scrollLeft >= max;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', refresh, { passive: true });
    window.addEventListener('resize', refresh);

    refresh();
    // Images can change the scroll width after they load.
    window.setTimeout(refresh, 400);
  }

  function init(root) {
    var scope = root || document;
    var sliders = scope.querySelectorAll('[data-atn-ss-slider]');
    for (var i = 0; i < sliders.length; i++) setup(sliders[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();